var map = {
	"./all.svg": "3391",
	"./at.svg": "4919",
	"./ch.svg": "b6af",
	"./de.svg": "eca6",
	"./en.svg": "54f5",
	"./fr.svg": "8f00",
	"./it.svg": "a248",
	"./nl.svg": "7cbb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d9a5";